export default __webpack_public_path__ + "static/media/004-B-loisirs.0de62d62.svg";